import { adminHttpClient } from '../commons/adminHttpClient'

export type DashboardInfoStatisticForAdminResponse = {
  totalReimbursementDue: number
  totalReimbursementAmount: number
  totalReimbursementRequests: number
  previousPlanPeriodDetails: PreviousPlanPeriodDetailsResponse
}

export type PreviousPlanPeriodDetailsResponse = {
  previousPlanPeriodId: string
  totalReimbursementDue: number
  totalReimbursementAmount: number
  totalReimbursementRequests: number
}

const getDashboardInfoStatisticForAdmin = (planPeriodId: string): Promise<DashboardInfoStatisticForAdminResponse> => {
  return adminHttpClient.get(`/Benefit/DashboardInfoStatisticForAdmin/${planPeriodId}`, {})
}

export default getDashboardInfoStatisticForAdmin
